import React, {Component} from 'react';
import * as d3 from 'd3';
import ReactDOM from 'react-dom';
import './piechart.css';

let margin = {
    top: 20,
    right: 20,
    bottom: 20,
    left: 20,
};

export function genData() {
    return [
        {key: 'foo', value: 24, color: '#15164d'},
        {key: 'bar', value: 54, color: '#cc0306'},
    ];
}

function initGraph(el) {
    let svg = d3.select(el);
    let rect = el.parentNode.getBoundingClientRect();
    let height = rect.height - margin.top - margin.bottom;
    let width = rect.width - margin.left - margin.right;
    let radius = Math.min(width / 2, height / 2) * .9;

    let g = svg.append('g')
        .attr('class', 'con')
        .attr('transform', 'translate(' + (width / 2 + margin.left) + ',' + (height / 2 + margin.top) + ')');

    let arc = d3.arc()
        .innerRadius(radius * .5)
        .outerRadius(radius);
    
    g.append('path')
        .attr('class', 'plchdr')
        .attr('fill', '#ccc')
        .attr('d', () => arc({startAngle: 0, endAngle: 2 * Math.PI}));
}

function updateData(el, data) {
    let svg = d3.select(el);
    let rect = el.getBoundingClientRect();
    let height = rect.height - margin.top - margin.bottom;
    let width = rect.width - margin.left - margin.right;
    let radius = Math.min(width / 2, height / 2) * .9;

    let g = svg.select('g.con');

    let arc = d3.arc()
        .innerRadius(radius * .5)
        .outerRadius(radius)
        .padAngle(.01);

    let pie = d3.pie()
        .value(d => d.value);

    let arcs = g.selectAll('g.slice').data(pie(data))
    let arcs2 = arcs.enter().append('g')
        .attr('class', 'slice')
        .merge(arcs)
        let path = arcs2.select('path');
        if(path.empty()) path = arcs2.append('path');
        path.attr('fill', d => d.data.color)
            // .transition().duration(500)
            .attr('d', arc)
            // .attr('d', arcTween(Math.random() * 2 * Math.PI))
        path.on('mouseenter', function() {
            let arc = d3.arc()
                .innerRadius(radius * .5)
                .outerRadius(radius + 5)
                .padAngle(.01);
            d3.select(this).transition().duration(50).attr('d', arc);
        }).on('mouseleave', function() {
            d3.select(this).transition().duration(50).attr('d', arc);
        });
        let text = arcs2.select('text.ins');
        if(text.empty()) text = arcs2.append('text').attr('class', 'ins');
        text.attr('transform', d => {
                let arc = d3.arc().innerRadius(radius).outerRadius(radius + 50);
                let point = arc.centroid(d);
                point[1] += 5;
                return 'translate(' + point + ')';
            })
            .text(d => d.data.label);
    arcs2.exit().remove();
    arcs.exit().remove();
}

class PieChart extends Component {
    state = {
        idlePerc: 0,
    }
    componentDidMount() {
        initGraph(ReactDOM.findDOMNode(this));
        document.addEventListener('visibilitychange', this.visibilityChange);
    }
    setData = (data) => {
        let action = () => updateData(ReactDOM.findDOMNode(this), data);
        if(document.visibilityState === 'visible') action();
        else this.onVisible = action;
    }
    redraw = () => {
        updateData(ReactDOM.findDOMNode(this), this.props.data);
    }
    visibilityChange = () => {
        if(this.onVisible && document.visibilityState === 'visible') {
            this.onVisible();
            delete this.onVisible;
        }
    }
    render() {
        return (
            <svg></svg>
        )
    }
}

export default PieChart;